import axios from "axios";

/**
 * Factory for axios instances with a fixed base URL and default headers.
 */
export function createApiClient({ baseURL, headers = {} }) {
  return axios.create({
    baseURL,
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
      ...headers,
    },
  });
}
